export default __webpack_public_path__ + "static/media/Astrodings.2d7fe562.woff2";